import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const InformationCircleSolidIcon = forwardRef<SVGSVGElement, IconProps>(function InformationCircleSolidIcon(
  { color, height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_101_5783)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM10.125 4.5C10.125 5.12132 9.62132 5.625 9 5.625C8.37868 5.625 7.875 5.12132 7.875 4.5C7.875 3.87868 8.37868 3.375 9 3.375C9.62132 3.375 10.125 3.87868 10.125 4.5ZM7.875 7.875C7.25368 7.875 6.75 8.37868 6.75 9C6.75 9.62132 7.25368 10.125 7.875 10.125V13.5C7.875 14.1213 8.37868 14.625 9 14.625H10.125C10.7463 14.625 11.25 14.1213 11.25 13.5C11.25 12.8787 10.7463 12.375 10.125 12.375V9C10.125 8.37868 9.62132 7.875 9 7.875H7.875Z"
          fill={color || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_101_5783">
          <rect width="18" height="18" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
});
